import { createSlice } from '@reduxjs/toolkit';

const logoutSlice = createSlice({
  name: 'logout',
  initialState: {
    fromAuth0: false,
    logoutSuccess: false,
  },
  reducers: {
    logoutAction: (state, action) => {
      state.fromAuth0 = !!action.payload?.fromAuth0;
      state.logoutSuccess = false;
    },
    logoutSuccessAction: (state, action) => {
      state.fromAuth0 = !!action.payload?.fromAuth0;
      state.logoutSuccess = true;
    },
    logoutFailureAction: (state) => {
      state.logoutSuccess = false;
    },
  },
});

export const {
  logoutAction,
  logoutSuccessAction,
  logoutFailureAction,
} = logoutSlice.actions;

export default logoutSlice.reducer;
